module.exports = __webpack_public_path__ + "img/p1-t4.46b13a9d.png";